module.exports = __webpack_public_path__ + "img/settings.660a21f4.svg";